export default "__VITE_PUBLIC_ASSET__44e8b0fe__"